import React, { useState, useEffect } from "react";
import { getUserToken } from "../libs/user";
import ImageDone from "../assets/img/done_icon.svg";
import ImageFail from "../assets/img/bank_fail.svg";
import { dismissCards, staticPayLoad } from "../services/plaid";
function SnackBar({ getTopCards, closeBtn, refresh }) {
  const [successTopCardsId, setsuccessTopCardsId] = useState([]);
  const [successSnackBar, setsuccessSnackBar] = useState([]);
  const [pendingTopCardsId, setpendingTopCardsId] = useState([]);
  const [pendingSnackBar, setpendingSnackBar] = useState([]);
  const [failureTopCardsId, setfailureTopCardsId] = useState([]);
  const [failureSnackBar, setfailureSnackBar] = useState([]);
  const [manuallyVerifyTopCardsId, setmanuallyVerifyTopCardsId] = useState([]);
  const [manuallyVerifySnackBar, setmanuallyVerifySnackBar] = useState([]);
  const [securitypopup, setsecuritypopup] = useState(false);
  const [errorpop, seterrorpop] = useState(false);
  const [manuallyVerifypopup, setmanuallyVerifypopup] = useState(false);

  const authToken = getUserToken();
  const ClosePopup = () => {
    setsecuritypopup(false);
    seterrorpop(false);
    setmanuallyVerifypopup(false);
  };

  useEffect(() => {}, []);

  useEffect(() => {
    if (authToken) {
      staticPayLoad(authToken)
        .then((response) => {
          if (getTopCards && response.success === true) {
            getTopCards(response?.topCardsPayload || []);
          }
          var i;
          const successCardsId = [];
          const successSnackBar = [];
          const pendingCardsId = [];
          const pendingSnackBar = [];
          const failureCardsId = [];
          const failureSnackBar = [];
          const manuallyVerifyCardsId = [];
          const manuallyVerifySnackBar = [];
          for (i = 0; i < response.topCardsPayload.length; i++) {
            if (response.topCardsPayload[i].eventType == "pending_bank_link") {
              var text =
                response.topCardsPayload[i].title +
                " " +
                response.topCardsPayload[i].subtitle;
              if (
                !pendingTopCardsId.includes(
                  response.topCardsPayload[i].uniqueId
                )
              ) {
                pendingTopCardsId.push(response.topCardsPayload[i].uniqueId);
                pendingSnackBar.push({
                  id: response.topCardsPayload[i].uniqueId,
                  message: text,
                });
              }
            }
            if (
              response.topCardsPayload[i].eventType == "confirmed_bank_link"
            ) {
              var text =
                response.topCardsPayload[i].title +
                " " +
                response.topCardsPayload[i].subtitle;
              if (!successTopCardsId.includes(response.topCardsPayload[i].id)) {
                successCardsId.push(response.topCardsPayload[i].id);

                successSnackBar.push({
                  id: response.topCardsPayload[i].id,
                  message: text,
                });
              }
            }
            if (
              response.topCardsPayload[i].eventType == "duplicate_bank_link"
            ) {
              var text =
                response.topCardsPayload[i].title +
                " " +
                response.topCardsPayload[i].subtitle;
              if (!failureTopCardsId.includes(response.topCardsPayload[i].id)) {
                failureTopCardsId.push(response.topCardsPayload[i].id);
                failureSnackBar.push({
                  id: response.topCardsPayload[i].id,
                  message: text,
                });
              }
            }
            if (
              response.topCardsPayload[i].eventType ==
              "manual_verification_bank_link"
            ) {
              var text =
                response.topCardsPayload[i].title +
                " " +
                response.topCardsPayload[i].subtitle;
              if (
                !manuallyVerifyTopCardsId.includes(
                  response.topCardsPayload[i].id
                )
              ) {
                manuallyVerifyTopCardsId.push(response.topCardsPayload[i].id);
                manuallyVerifySnackBar.push({
                  id: response.topCardsPayload[i].id,
                  message: text,
                });
              }
            }
          }
          setsuccessTopCardsId(successCardsId);
          setsuccessSnackBar(successSnackBar);
          setfailureSnackBar(failureSnackBar);
          setfailureTopCardsId(failureTopCardsId);
          setpendingSnackBar(pendingSnackBar);
          setpendingTopCardsId(pendingTopCardsId);
          setmanuallyVerifySnackBar(manuallyVerifySnackBar);
          setmanuallyVerifyTopCardsId(manuallyVerifyTopCardsId);
        }) //response
        .catch((error) => {
          console.log(error);
        });
    }
  }, []);
  const successSnackBarClick = (itemId) => {
    const index = successTopCardsId.indexOf(itemId);
    if (index > -1) {
      successTopCardsId.splice(index, 1);
    }
    for (var j = 0; j < successSnackBar.length; j++) {
      successSnackBar.splice(j, 1);
    }
    //
    dismissCards(authToken, itemId)
      .then((response) => {})
      .catch(function (error) {
        console.log(error);
      });
    //

    setsecuritypopup(true);
  };

  const failureSnackBarClick = (itemId) => {
    const index = failureTopCardsId.indexOf(itemId);
    if (index > -1) {
      failureTopCardsId.splice(index, 1);
    }
    for (var j = 0; j < failureSnackBar.length; j++) {
      failureSnackBar.splice(j, 1);
    }
    //
    dismissCards(authToken, itemId)
      .then((response) => {})
      .catch(function (error) {
        console.log(error);
      });
    seterrorpop(true);
  };

  const ManuallyVerifySnackBarClick = (itemId) => {
    const index = manuallyVerifyTopCardsId.indexOf(itemId);
    if (index > -1) {
      manuallyVerifyTopCardsId.splice(index, 1);
    }
    for (var j = 0; j < manuallyVerifySnackBar.length; j++) {
      manuallyVerifySnackBar.splice(j, 1);
    }
    //
    dismissCards(authToken, itemId)
      .then((response) => {})
      .catch(function (error) {
        console.log(error);
      });
    //

    manuallyVerifypopup(true);
  };

  return (
    <>
      <div>
        {pendingSnackBar.length > 0 && (
          <div>
            <div className="snack-bar linking">
              <div className="snack-bar-info">
                <div className="spinner-border"></div>
                <p> Pending </p>
              </div>
            </div>
          </div>
        )}
        {failureSnackBar.length > 0 && (
          <div>
            {failureSnackBar.map((item, index) => {
              <div className="snack-bar failed">
                <div className="snack-bar-info">
                  <div className="bank-icon">
                    <span className="bank-rgt-icon"></span>
                  </div>

                  <p data-index={index}> {item.message} </p>
                </div>
                {closeBtn === true && (
                  <button
                    type="button"
                    className="snack-close-btn"
                    onClick={() => failureSnackBarClick(item.id)}
                  ></button>
                )}
              </div>;
            })}
          </div>
        )}
        {successSnackBar.length > 0 && (
          <div>
            {successSnackBar.map((item, index) => {
              return (
                <div className="snack-bar success" key={index}>
                  <div className="snack-bar-info">
                    <div className="bank-icon">
                      <span className="bank-rgt-icon"></span>
                    </div>

                    <p data-index={index}> {item.message} </p>
                    {closeBtn === true && (
                      <button
                        type="button"
                        className="snack-close-btn"
                        onClick={() => successSnackBarClick(item.id)}
                      ></button>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {manuallyVerifySnackBar.length > 0 && (
          <div>
            {manuallyVerifySnackBar.map((item, index) => {
              return (
                <div className="snack-bar success" key={index}>
                  <div className="snack-bar-info">
                    <div className="bank-icon">
                      <span className="bank-rgt-icon"></span>
                    </div>

                    <p data-index={index}> {item.message} </p>
                    {closeBtn === true && (
                      <button
                        type="button"
                        className="snack-close-btn"
                        onClick={() => ManuallyVerifySnackBarClick(item.id)}
                      ></button>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {errorpop === true && (
        <div className="popUpOverlay">
          <div className="popUpInner">
            <div className="popUpBox successBox noBorder">
              <div
                className="doneBox"
                style={{ background: "none", width: "100%" }}
              >
                <img src={ImageFail} />
              </div>
              <div className="popupTxt">
                <h3>Bank link failed</h3>

                <p>
                  Sorry, we don't support this bank. Please try again with some
                  other bank account.
                </p>
              </div>
              <div className="popupBtnSec">
                <button
                  type="submit"
                  style={{ padding: "10px 61px", width: "100%" }}
                  className="btn btn-primary popupBtn"
                  onClick={ClosePopup}
                >
                  Try Again
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {manuallyVerifypopup === true && (
        <div className="popUpOverlay">
          <div className="popUpInner">
            <div className="popUpBox successBox noBorder">
              <div className="doneBox" style={{ background: "none" }}>
                <img src={{ ImageFail }} />
              </div>
              <div className="popupTxt">
                <h3>Bank link failed</h3>
                <p>
                  Sorry something went wrong while we were adding your bank
                  account to Abound. Please reach out to our customer chat
                  support to get this resolved.
                </p>
              </div>
              <div className="popupBtnSec">
                <button
                  type="submit"
                  style={{ padding: "10px 61px", width: "100%" }}
                  className="btn btn-primary popupBtn"
                  onClick={ClosePopup}
                >
                  Try Again
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {securitypopup === true && (
        <div className="popUpOverlay">
          <div className="popUpInner">
            <div className="popUpBox successBox noBorder">
              <div className="doneBox">
                <img src={ImageDone} />
              </div>
              <div className="popupTxt">
                <h3>Success!</h3>
                <p>Your account has been securely linked to Abound.</p>
              </div>

              <div className="popupBtnSec">
                <button
                  type="submit"
                  className="btn btn-primary popupBtn"
                  onClick={ClosePopup}
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

SnackBar.defaultProps = {
  getTopCards: undefined,
  closeBtn: true,
  refresh: 0,
};

export default SnackBar;
